module.exports = __webpack_public_path__ + "static/img/50.7614f726.gif";